import { DOCUMENT_EXTENSIONS, DOCUMENT_REQUEST_LOCATION, IDocumentRequest } from "../../../models/utilities/document-request";
import { API_METHODS } from "../../../models/utilities/type-models";
import { ApiEndpoints } from "../../../utils/app-constants";
import { AppUtils } from "../../../utils/app-utils";
import { EngineeringReviewSearchFilters } from "./engineering-review-search-filters";

export class DocumentEngineeringReviewQueryExport implements IDocumentRequest {

    public filename : string = '';
    public fileExtension : DOCUMENT_EXTENSIONS = 'xlsx';
    public openInTab : boolean = false;
    public url : string = ''; 
    public reportLocation : DOCUMENT_REQUEST_LOCATION = 'api';
    public methodType : API_METHODS = 'GET';

    constructor(filters: EngineeringReviewSearchFilters) {        
        this.url = AppUtils.convertFiltersToUrl(ApiEndpoints.ORDERING_ENGINEERING_REVIEW_EXPORT, filters);
        this.filename = 'Engineering_Review_Export';
    }
}
